import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	createArticleCta: {
		id: 'servicedesk.knowledge-hub.knowledge-hub-browse-all-articles.create-article-cta',
		defaultMessage: 'Create article',
		description: 'Create article cta which links out to Confluence',
	},

	noArticlesTitleMultipleSpaces: {
		id: 'servicedesk.knowledge-hub.knowledge-hub-browse-all-articles.no-articles-title-multiple-spaces',
		defaultMessage: "We couldn't find an article matching your search",
		description:
			'Title shown when there are no articles in the knowledge base for Multi space view',
	},

	noArticlesTitle: {
		id: 'servicedesk.knowledge-hub.knowledge-hub-browse-all-articles.no-articles-title',
		defaultMessage: 'There are no articles in your knowledge base',
		description: 'Title shown when there are no articles in the knowledge base',
	},

	noArticlesDescription: {
		id: 'servicedesk.knowledge-hub.knowledge-hub-browse-all-articles.no-articles-description',
		defaultMessage: "Articles can help your help seekers find the solutions they're looking for.",
		description: 'Description shown when there are no articles in the knowledge base',
	},

	noArticlesDescriptionMultipleSpaces: {
		id: 'servicedesk.knowledge-hub.knowledge-hub-browse-all-articles.no-articles-description-multiple-spaces',
		defaultMessage: 'Consider {creating} a new one',
		description:
			"Description shown when there are no articles in the knowledge base. LOCALIZATION NOTE (noArticlesDescriptionMultipleSpaces): {{creating}} will be replaced at run-time by an active link. the string 'creatingArticleDescription' will be used as text for this link. noArticlesDescriptionMultipleSpaces = Consider {{creating}} a new one.creatingArticleDescription = creating",
	},

	creatingArticleDescription: {
		id: 'servicedesk.knowledge-hub.knowledge-hub-browse-all-articles.creating-article-description',
		defaultMessage: 'creating',
		description: 'Description shown when there are no articles in the knowledge base',
	},

	noArticlesCta: {
		id: 'servicedesk.knowledge-hub.knowledge-hub-browse-all-articles.no-articles-cta',
		defaultMessage: 'Create article',
		description: 'Call to action shown when there are no articles in the knowledge base',
	},

	welcomeDescription: {
		id: 'servicedesk.knowledge-hub.knowledge-hub-browse-all-articles.welcome-description',
		defaultMessage:
			'Create articles in knowledge base spaces to share information with your team and to let customers self-serve.',
		description:
			'Welcome text customers see when they come to the knowledge hub. It is displayed as a sub title.',
	},

	welcomeDescriptionNew: {
		id: 'servicedesk.knowledge-hub.knowledge-hub-browse-all-articles.welcome-description-new',
		defaultMessage:
			'Create articles in knowledge base spaces to share information with your team and to let customers self-serve.',
		description:
			'Welcome text customers see when they come to the knowledge hub. It is displayed as a sub title.',
	},

	welcomeDescriptionCrossSiteArticlesTable: {
		id: 'servicedesk.knowledge-hub.knowledge-hub-browse-all-articles.welcome-description-cross-site-articles-table',
		defaultMessage:
			'View articles from Confluence spaces that your admin has linked to this project. ',
		description:
			'elcome text customers see when they come to the knowledge hub if they have cross site spaces linked to knowledge base. It is displayed as a sub title',
	},
	welcomeDescriptionCrossSiteArticlesTableLink: {
		id: 'servicedesk.knowledge-hub.knowledge-hub-browse-all-articles.welcome-description-cross-site-articles-table-link',
		defaultMessage: 'Manage knowledge sources',
		description: 'Link text for knowledge base settings',
	},

	welcomeDescriptionAdmins: {
		id: 'servicedesk.knowledge-hub.knowledge-hub-browse-all-articles.welcome-description-admins',
		defaultMessage: 'Manage your spaces and permissions in {linkText}',
		description:
			'This text is only to be displayed to admins to help them in managing permissions by linking knowledge-settings',
	},
	viewAll: {
		id: 'servicedesk.knowledge-hub.knowledge-hub-browse-all-articles.view-all',
		defaultMessage: 'View all',
		description: 'Text for view all link',
	},

	welcomeDescriptionAdminsLink: {
		id: 'servicedesk.knowledge-hub.knowledge-hub-browse-all-articles.welcome-description-admins-link',
		defaultMessage: 'knowledge base settings',
		description: 'Link text for knowledge base settings link to be displayed to admins',
	},

	welcomeDescriptionNoCategories: {
		id: 'servicedesk.knowledge-hub.knowledge-hub-browse-all-articles.welcome-description-no-categories',
		defaultMessage:
			'Share solutions to problems with your customers and team by adding articles to your knowledge base.',
		description:
			'Welcome text customers see when they come to the knowledge hub. It is displayed as a sub title.',
	},

	inlineSearchPlaceholder: {
		id: 'servicedesk.knowledge-hub.knowledge-hub-browse-all-articles.inline-search-placeholder',
		defaultMessage: 'Search all articles',
		description: 'Default placeholder for the inline search dialog for articles',
	},

	searchPlaceholder: {
		id: 'servicedesk.knowledge-hub.knowledge-hub-browse-all-articles.search-placeholder',
		defaultMessage: 'Search',
		description: 'Default placeholder for article search',
	},
	topicSubtitle: {
		id: 'servicedesk.knowledge-hub.knowledge-hub-browse-all-articles.topic-subtitle',
		defaultMessage:
			'Based on {workItemCount} related {workItemCount, plural, one {work item} other {work items}}',
		description: 'Subtitle for suggested topic card',
	},
	suggestedTopicsTitle: {
		id: 'servicedesk.knowledge-hub.knowledge-hub-browse-all-articles.suggested-topics-title',
		defaultMessage: 'Suggested topics',
		description: 'Title for suggested topics section',
	},
	spacesDropdownText: {
		id: 'servicedesk.knowledge-hub.knowledge-hub-browse-all-articles.spaces-dropdown-text',
		defaultMessage: '{count, plural, =0 {Spaces} one {{spaceName}} other {Multiple (# spaces)}}',
		description: 'Dropdown Text shown when multiple spaces are selected',
	},

	searchLabelText: {
		id: 'servicedesk.knowledge-hub.knowledge-hub-browse-all-articles.search-label-text',
		defaultMessage: 'Search for articles',
		description: 'aria-label text for article search',
	},

	searchArticlesHintText: {
		id: 'servicedesk.knowledge-hub.knowledge-hub-browse-all-articles.search-articles-hint-text',
		defaultMessage: 'The table below will get updated as you type characters in the field.',
		description: 'description text for search results for articles getting live updates',
	},
	noArticlesFound: {
		id: 'servicedesk.knowledge-hub.knowledge-hub-browse-all-articles.no-articles-found',
		defaultMessage: 'No articles found',
		description: 'No articles found message',
	},
});
